module.exports = __webpack_public_path__ + "img/houricon.b564743e.svg";